import { Box, Chip, Typography } from "@mui/material"
import { CloseFilledOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { Location } from "@/graphql/codegen/graphql"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

interface ShipToLocationCardProps {
  location: Location
  onRemove: (locationId: string) => void
}

export const ShipToLocationCard: FC<ShipToLocationCardProps> = ({ location, onRemove }) => {
  const { locationId, name, accountManager } = location
  const address = formatLocationAddress(location, AddressFormat.AddressOnly)

  return (
    <Chip
      label={
        <Box className='flex min-h-9 flex-col justify-center'>
          <Typography className='text-sm font-normal text-gray-800'>
            {name}
            {address ? ` - ${address}` : ""}
          </Typography>
          {accountManager && (
            <Typography className='text-xs font-normal text-gray-600'>
              Account Manager: {accountManager.firstName} {accountManager.lastName}
            </Typography>
          )}
        </Box>
      }
      onDelete={() => onRemove(locationId)}
      deleteIcon={<CloseFilledOutlined className='!h-4 !w-4' />}
      className='h-auto w-full justify-between rounded-lg bg-gray-200'
      sx={{
        "& .MuiChip-label": { display: "block", padding: "8px 12px", whiteSpace: "normal" },
        "& .MuiChip-deleteIcon": { marginRight: "8px", flexShrink: 0 },
      }}
      data-testid={`sales.ship-to-location-card.${locationId}`}
    />
  )
}
